import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * SMTP Send Email v2 Configuration Validator
 * Validates SMTP email configuration including connection, recipients, content, and attachments
 */
export const SMTP_Send_Email_2_ConfigValidator = z.object({
    smtpConnection: requiredString('SMTP Connection is required'),
    emailFrom: requiredString('From Email is required'),
    emailTo: requiredString('To Email is required'),
    emailCc: z.string().optional(),
    emailSubject: requiredString('Email Subject is required'),
    emailBody: requiredString('Email Body is required'),
    includeAttachments: z.boolean().default(false)
});
//# sourceMappingURL=smtp-send-email-2.js.map